export enum PermissionType {
  View = 'view',
  Update = 'upd',
  Add = 'ins',
  Delete = 'del',
  Load = 'load',
}

export const WORKFLOW_PERMISSION_FEATURE = 'itms/automation';
